export enum ShortcutAction {
    /* General actions */
    Delete = 'Del',
    Cancellation = 'Esc',
    Rotate = 'R',
    Transform = 'T',
    MultiSelection = 'Ctrl+LMB',
    SelectAll = 'Ctrl+A',
    Copy = 'Ctrl+C',
    Paste = 'Ctrl+V',
    Cut = 'Ctrl+X',
    Group = 'Ctrl+G',
    Ungroup = 'Ctrl+Shift+G',
    LeftMouseButton = 'LMB',
    MiddleMouseButton = 'MMB',
    RightMouseButton = 'RMB',
    Previous = 'A or ArrowLeft',
    Next = 'D or ArrowRight',
    NumberKey = 'Number key (1-n)',
    Execute = 'E or Enter',
    SaveProject = 'Ctrl+S',

    /* View actions */
    LockView = 'L',
    UnlockView = 'U',
    FocusBuilding = 'MMB 2x',

    /* Camera and POI actions */
    RotateCamera = 'Shift + MMB pressed',
    PoiNavigationMode = 'P',
    TemporaryPoiNavigation = 'Space pressed',
    SwitchPoiType = 'Tab',
    SwitchPoiTypeReverse = 'Shift+Tab',
    ToggleCameraRealignment = 'C',
    ListNavigation = 'ArrowUp/Down or W/S'
}
